<template>
  <div class="main" :style="{backgroundImage:'url('+info.img+')'}">
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <div class="contentBox">
        <div class="itemBox" v-for="(item, index) of lists" :key="index" @click="toAppActive(item)">
          <img :src="item.img" alt="" />
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
  import {
    getActivityList,
    getDictionary
  } from '../api/active.js'
  import {
    NavBar,
    PullRefresh,
    Toast
  } from 'vant';
  // const tokenL =
  //   'bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaWQiOiIxMDQ3MDQiLCJjb21wYW55X3R5cGUiOiIwMyIsInRoaXNfcm9sZV9pZCI6bnVsbCwidXNlcl9uYW1lIjoiMTgzMDM0MTA1MjEgIiwibWVtYmVyX2xldmVsX2lkIjotMSwiZW1wb3dlcl9zdGF0dXMiOjEsInJlYWxfbmFtZSI6IjE4MzAzNDEwNTIxIiwiYXVkaXRfc3RhdHVzIjo0LCJjbGllbnRfaWQiOiIzYWstcGMiLCJkaXNhYmxlX3N0YXR1cyI6MCwidXNlcl90eXBlIjoicGMiLCJyb2xlX2lkIjoiMTEyMzU5ODgxNjczODY3NTIwMiIsInNjb3BlIjpbImFsbCJdLCJvYXV0aF9pZCI6IiIsImlkX3R5cGUiOjIsIm1lbWJlcl9zdG9yZV9pZCI6MTQwNDY5NjI3MDA3NzU0NjQ5OCwiZXhwIjoxNjI2MzI5OTgyLCJqdGkiOiIyMjg2ZGNjZi0xZDk1LTRjNDAtYWQ1MC1jNGYyNTc2YmJiZTMiLCJtZW1iZXJfaWQiOjE0MDQ2OTYyNzAwNDgxODYzNzAsInN0b3JlX2lkIjotMSwiYXZhdGFyIjoiIiwiYXV0aG9yaXRpZXMiOlsidXNlciJdLCJyb2xlX25hbWUiOiJ1c2VyIiwibGljZW5zZSI6InBvd2VyZWQgYnkgYmxhZGV4IiwicG9zdF9pZCI6IiIsInVzZXJfaWQiOiIxNDA0Njk2MjY5OTE4MTYyOTQ2Iiwibmlja19uYW1lIjoiMTgzMDM0MTA1MjEiLCJkZXB0X2lkIjoiIiwiYWNjb3VudCI6IjE4MzAzNDEwNTIxICJ9.IE0Mj5MR7cLEj_7LG5a1Uyu0GkD7QPVsCLKobGswj0A'
  export default {
    name: "Activity",
    components: {
      NavBar,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
    },
    data() {
      return {
        refreshLoading: false,
        lists: [],
        info: {},
        access_token: '', //token
        activeDictionary: []
      };
    },
    created() {
      // this.fetchData()
      // this.fetchActiveType()
    },
    methods: {
      // 活动列表
      async fetchData(token) {
        if (!token) {
          token = this.getTokenNew()
        }
        const result = await getActivityList(token, {})

        if (result.code === 200) {
          this.lists = result.data.activityOperationDetails
          this.info = result.data
        } else {
          this.lists = []
          this.info = {}
        }
        this.refreshLoading = false
      },
      // 活动列表字典
      async fetchActiveType(token) {
        if (!token) {
          token = this.getTokenNew()
        }
        const result = await getDictionary(token, {
          code: 'content_activityoperationType',
        })

        if (result.code === 200) {
          this.activeDictionary = result.data
        } else {
          this.activeDictionary = []
        }
      },
      //token赋值
      getTokenNew() {
        if (this.access_token) {
          return this.access_token
        }
        // else { //仅测试用
        //   return tokenL
        // }
      },
      //跳转app
      toAppActive(value) {

        if (this.activeDictionary.length > 0) {
          const item = this.activeDictionary.find(v => Number(v.dictKey) === value.activityType)
          let key = ''
          if (item) {
            switch (item.dictKey) {
              case '0': //a+b
                key = 'jumpAaddB'
                break
              case '1': //"套餐"
                key = 'jumpSetMeal'
                break
              case '2': //"预售"
                key = 'jumpBeforeSale'
                break
              case '3': //"拼团"
                key = 'jumpSpellGroup'
                break
              case '4': //"限时购"
                key = 'jumpTimeLimitSale'
                break
              case '5': //小额包邮
                key = 'jumpFreeMailGoods'
                break
              case '6':
                break
              case '7':
                break
              default:
                break
            }
            if (key) {
              let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
              const data = {}
              if (isiOS) { //ios
                window.webkit.messageHandlers[key].postMessage(data)
              } else { //android
                this.$bridge.callHandler(key, data, res => {});
              }
            }
          } else {
            this.$toast('无法匹配活动类型')
          }
        } else {
          this.$toast('活动字典为空,请下拉刷新')
        }
      },
      // 刷新
      onRefresh() {
        this.fetchData()
        this.fetchActiveType()
      },
      // 点击跳转详情页   js跳转app
      jumpDetail(id, isRecentExpiration) {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let detailsData = {
          goods_id: id,
          isRecentExpiration: isRecentExpiration,
        }
        if (isiOS) {
          window.webkit.messageHandlers.jumpGoodsDetail.postMessage(detailsData)
        } else {
          this.$bridge.callHandler("jumpGoodsDetail", detailsData, res => {});
        }
      },
      // 安卓app调js   获取列表数据
      getAPPDate() {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {

        } else {
          this.$bridge.registerHandler("getToken", (data, responseCallback) => {

            this.access_token = "bearer " + data
            this.fetchData(this.access_token)
            this.fetchActiveType(this.access_token)
            responseCallback(data);
          });
        }
      },
      getToken(token) {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          // 苹果app调取js方法  获取列表数据

          this.access_token = "bearer " + data
          this.fetchData(this.access_token)
          this.fetchActiveType(this.access_token)
          //  alert("获取app响应数据:" + access_token);
        }
      },
    },
    //   注册方法
    mounted() {
      // 注册安卓方法
      window.getToken = this.getToken //ios使用
      this.getAPPDate();
    }
  };

</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    min-height: 100vh;
    background-size: 100% 100%;
  }

  .contentBox {
    margin-top: 0.2rem;
    margin: 0 auto;
    width: 3.2rem;
  }

  .itemBox {
    width: 100%;
    height: 1.3rem;
    border-radius: 0.2rem;
    margin: 0.06rem 0;
    overflow: hidden;

    >img {
      width: 100%;
      height: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Activity.vue